import { render, staticRenderFns } from "./muchMore.vue?vue&type=template&id=35f7816e&scoped=true"
import script from "./muchMore.vue?vue&type=script&lang=js"
export * from "./muchMore.vue?vue&type=script&lang=js"
import style0 from "./muchMore.vue?vue&type=style&index=0&id=35f7816e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f7816e",
  null
  
)

export default component.exports